var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.00488H7M22 10.9749V13.0349C22 13.5849 21.56 14.0349 21 14.0549H19.04C17.96 14.0549 16.97 13.2649 16.88 12.1849C16.82 11.5549 17.06 10.9649 17.48 10.5549C17.85 10.1749 18.36 9.95488 18.92 9.95488H21C21.56 9.97488 22 10.4249 22 10.9749Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.48 10.5549C17.06 10.9649 16.82 11.5549 16.88 12.1849C16.97 13.2649 17.96 14.0549 19.04 14.0549H21V15.5049C21 18.5049 19 20.5049 16 20.5049H7C4 20.5049 2 18.5049 2 15.5049V8.50488C2 5.78488 3.64 3.88488 6.19 3.56488C6.45 3.52488 6.72 3.50488 7 3.50488H16C16.26 3.50488 16.51 3.51488 16.75 3.55488C19.33 3.85488 21 5.76488 21 8.50488V9.95488H18.92C18.36 9.95488 17.85 10.1749 17.48 10.5549Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.2e8088f0f3316dd143a1249c480faeb4.svg";
export { ForwardRef as ReactComponent };